var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 387,
    height: 74,
    viewBox: "0 0 387 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0731 22.2342L32.126 52H15.4804L0 0H18.2269L25.1349 32.8649H25.4678L34.4148 0H48.0642L57.0112 32.8649H57.3441L64.2521 0H82.479L66.9986 52H50.353L41.406 22.2342H41.0731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8529 52H80.2086V0H97.8529V52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.247 52V42.4144L124.005 12.4324V12.1441H97.4967V0H144.562V9.54955L117.888 39.5676V39.8559H145.561V52H97.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.613 52L181.492 41.6577H163.182L160.061 52H142.084L161.684 0H183.822L203.423 52H184.613ZM172.171 12L166.386 30.8829H178.288L172.503 12H172.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.38 11.2793V24.4685H225.663C228.132 24.4685 230.074 23.8679 231.489 22.6667C232.932 21.4655 233.653 19.8799 233.653 17.9099C233.653 15.964 232.918 14.3784 231.447 13.1532C229.977 11.9039 228.063 11.2793 225.705 11.2793H218.38ZM218.38 34.5586V52H200.736V0H227.411C235.345 0 241.365 1.53754 245.471 4.61261C249.605 7.68769 251.672 12.036 251.672 17.6577C251.672 20.8048 250.812 23.7117 249.092 26.3784C247.399 29.045 245.027 31.015 241.976 32.2883L253.378 52H233.653L224.165 34.5586H218.38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.236 52H250.733V0H280.237C286.368 0 291.14 1.15315 294.552 3.45946C297.993 5.74174 299.713 8.91291 299.713 12.973C299.713 15.9279 298.561 18.4505 296.259 20.5405C293.956 22.6066 291.043 23.8318 287.52 24.2162V24.5045C291.626 24.6006 295.135 25.8378 298.048 28.2162C300.961 30.5706 302.417 33.4535 302.417 36.8649C302.417 41.4294 300.489 45.0931 296.633 47.8559C292.777 50.6186 287.645 52 281.236 52ZM268.377 10.4865V20.8288H275.202C277.449 20.8288 279.238 20.3604 280.57 19.4234C281.902 18.4865 282.568 17.2252 282.568 15.6396C282.568 14.03 281.93 12.7688 280.653 11.8559C279.405 10.9429 277.671 10.4865 275.452 10.4865H268.377ZM268.377 41.5135H275.909C278.656 41.5135 280.764 40.997 282.235 39.964C283.733 38.9069 284.482 37.4054 284.482 35.4595C284.482 33.6096 283.733 32.1682 282.235 31.1351C280.737 30.1021 278.67 29.5856 276.034 29.5856H268.377V41.5135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.791 52H300.147V0H317.791V52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.187 52H331.542V12.1441H315.729V0H365V12.1441H349.187V52Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 387,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageTitle);
export default __webpack_public_path__ + "static/media/image-title.e5f121fb.svg";
export { ForwardRef as ReactComponent };